import PageTemplateData from '@v4/utils/data/PageTemplateData'

export const BANNER_VARIANTS = Object.freeze({
	VARIANT_1: 'banner-1',
	VARIANT_2: 'banner-2',
	VARIANT_3: 'banner-3',
	VARIANT_4: 'banner-4',
	VARIANT_5: 'banner-5',
	VARIANT_6: 'banner-6',
	VARIANT_7: 'banner-7',
	VARIANT_8: 'banner-8',
	VARIANT_9_10: 'banner-9_10',
	VARIANT_11: 'banner-11',
	VARIANT_12: 'banner-12',
	VARIANT_13: 'banner-13',
	VARIANT_15: 'banner-15',
	VARIANT_14: 'banner-14',
	VARIANT_16: 'banner-16',
	VARIANT_17: 'banner-17',
	VARIANT_23: 'banner-23',
})

export const CTA_VARIANTS = Object.freeze({
	VARIANT_1: 'cta-1',
	VARIANT_2: 'cta-2',
	VARIANT_3: 'cta-3',
	VARIANT_4: 'cta-4',
	VARIANT_5: 'cta-5',
	VARIANT_6: 'cta-6',
	VARIANT_7: 'cta-7',
	VARIANT_8: 'cta-8',
	VARIANT_9: 'cta-9',
	VARIANT_10: 'cta-10',
	VARIANT_12_13: 'cta-12_13',
	VARIANT_14: 'cta-14',
	VARIANT_15: 'cta-15',
	VARIANT_16_17: 'cta-16_17',
	VARIANT_18: 'cta-18',
})

export const CATEGORY_VARIANTS = Object.freeze({
	VARIANT_1: 'category-1',
	VARIANT_2: 'category-2',
	VARIANT_3: 'category-3',
	VARIANT_4: 'category-4',
	VARIANT_5: 'category-5',
	VARIANT_6: 'category-6',
	VARIANT_7: 'category-7',
	VARIANT_8: 'category-8',
	VARIANT_9: 'category-9',
})

export const CATEGORY_SCORES_VARIANTS = {
	VARIANT_1: 'result-1',
	VARIANT_2: 'result-2',
	VARIANT_3: 'result-3',
	VARIANT_4: 'result-4',
}

export const CONTENT_VARIANTS = Object.freeze({
	VARIANT_1: 'content-1',
	VARIANT_2: 'content-2',
	VARIANT_3: 'content-3',
	VARIANT_4: 'content-4',
	VARIANT_5: 'content-5',
	VARIANT_6: 'content-6',
	VARIANT_7: 'content-7',
	VARIANT_8: 'content-8',
})

export const FAQ_VARIANTS = Object.freeze({
	VARIANT_1: 'faq-1',
	VARIANT_2: 'faq-2',
	VARIANT_3: 'faq-3',
	VARIANT_4: 'faq-4',
})

export const FOOTER_VARIANTS = {
	VARIANT_1: 'footer-1',
}

export const FORM_VARIANTS = Object.freeze({
	VARIANT_1: 'default',
	VARIANT_2: 'form-2',
	VARIANT_3: 'form-3',
	VARIANT_4: 'form-4',
	VARIANT_5: 'form-5',
	VARIANT_6: 'form-6',
	VARIANT_7: 'form-7',
	VARIANT_8: 'form-8',
	VARIANT_9: 'form-9',
	VARIANT_10: 'form-10',
	VARIANT_11: 'form-11',
	VARIANT_12: 'form-12',
	VARIANT_13: 'form-13',
})

export const OVER_ALL_SCORE_VARIANTS = Object.freeze({
	DEFAULT: 'default',
	DONUT: 'donut',
	PIE: 'pie',
	RADAR: 'radar',
	SPEEDOMETER: 'speedometer',
	THERMOMETER: 'thermometer',
	TRAFFIC_LIGHT: 'traffic_light',
})

export const INDIVIDUAL_CATEGORY_VARIANTS = Object.freeze({
	VARIANT_1: 'single-category-1',
	VARIANT_2: 'single-category-2',
	VARIANT_3: 'single-category-3',
	VARIANT_4: 'single-category-4',
	VARIANT_5: 'single-category-5',
	VARIANT_6: 'single-category-6',
	VARIANT_7: 'single-category-7',
	VARIANT_8: 'single-category-8',
	VARIANT_9: 'single-category-9',
	VARIANT_10: 'single-category-10',
	VARIANT_11: 'single-category-11',
})

export const POPUP_VARIANTS = {
	SING_UP_LANDING: 'sing-up-landing',
	SING_UP_RESULT: 'sing-up-result',
	CHANGE_EMAIL: 'change-email',
}

export const TESTIMONIAL_VARIANTS = Object.freeze({
	VARIANT_1: 'testimonial-1',
	VARIANT_2: 'testimonial-2',
	VARIANT_3: 'testimonial-3',
	VARIANT_4: 'testimonial-4',
	VARIANT_5: 'testimonial-5',
	VARIANT_6: 'testimonial-6',
	VARIANT_7: 'testimonial-7',
})

export const VIDEO_VARIANTS = Object.freeze({
	VARIANT_1: 'video-1',
	VARIANT_2: 'video-2',
	VARIANT_3: 'video-3',
	VARIANT_4: 'video-4',
	VARIANT_5: 'video-5',
	VARIANT_6: 'video-6',
	VARIANT_7: 'video-7',
	VARIANT_8: 'video-8',
	VARIANT_9: 'video-9',
})

export const SMART_SECTIONS_VARIANTS = Object.freeze({
	VARIANT_1: 'smart-sections-1',
	VARIANT_2: 'smart-sections-2',
	VARIANT_3: 'smart-sections-3',
})

export const SECTION_VARIANTS = Object.freeze({
	[PageTemplateData.SECTION_TYPES.BANNER]: {
		[BANNER_VARIANTS.VARIANT_1]: 'Banner1',
		[BANNER_VARIANTS.VARIANT_2]: 'Banner2',
		[BANNER_VARIANTS.VARIANT_3]: 'Banner3',
		[BANNER_VARIANTS.VARIANT_4]: 'Banner4',
		[BANNER_VARIANTS.VARIANT_5]: 'Banner5',
		[BANNER_VARIANTS.VARIANT_6]: 'Banner6',
		[BANNER_VARIANTS.VARIANT_7]: 'Banner7',
		[BANNER_VARIANTS.VARIANT_8]: 'Banner8',
		[BANNER_VARIANTS.VARIANT_9_10]: 'Banner9_10',
		[BANNER_VARIANTS.VARIANT_11]: 'Banner11',
		[BANNER_VARIANTS.VARIANT_12]: 'Banner12',
		[BANNER_VARIANTS.VARIANT_13]: 'Banner13',
		[BANNER_VARIANTS.VARIANT_14]: 'Banner14',
		[BANNER_VARIANTS.VARIANT_15]: 'Banner15',
		[BANNER_VARIANTS.VARIANT_16]: 'Banner16',
		[BANNER_VARIANTS.VARIANT_17]: 'Banner17',
		[BANNER_VARIANTS.VARIANT_23]: 'Banner23',
	},
	[PageTemplateData.SECTION_TYPES.CALL_TO_ACTION]: {
		[CTA_VARIANTS.VARIANT_1]: 'Cta1',
		[CTA_VARIANTS.VARIANT_2]: 'Cta2',
		[CTA_VARIANTS.VARIANT_3]: 'Cta3',
		[CTA_VARIANTS.VARIANT_4]: 'Cta4',
		[CTA_VARIANTS.VARIANT_5]: 'Cta5',
		[CTA_VARIANTS.VARIANT_6]: 'Cta6',
		[CTA_VARIANTS.VARIANT_7]: 'Cta7',
		[CTA_VARIANTS.VARIANT_8]: 'Cta8',
		[CTA_VARIANTS.VARIANT_9]: 'Cta9',
		[CTA_VARIANTS.VARIANT_10]: 'Cta10',
		[CTA_VARIANTS.VARIANT_12_13]: 'Cta12_13',
		[CTA_VARIANTS.VARIANT_14]: 'Cta14',
		[CTA_VARIANTS.VARIANT_15]: 'Cta15',
		[CTA_VARIANTS.VARIANT_16_17]: 'Cta16_17',
		[CTA_VARIANTS.VARIANT_18]: 'Cta18',
	},
	[PageTemplateData.SECTION_TYPES.CATEGORY]: {
		[CATEGORY_VARIANTS.VARIANT_1]: 'Category1',
		[CATEGORY_VARIANTS.VARIANT_2]: 'Category2',
		[CATEGORY_VARIANTS.VARIANT_3]: 'Category3',
		[CATEGORY_VARIANTS.VARIANT_4]: 'Category4',
		[CATEGORY_VARIANTS.VARIANT_5]: 'Category5',
		[CATEGORY_VARIANTS.VARIANT_6]: 'Category6',
		[CATEGORY_VARIANTS.VARIANT_7]: 'Category7',
		[CATEGORY_VARIANTS.VARIANT_8]: 'Category8',
		[CATEGORY_VARIANTS.VARIANT_9]: 'Category9',
	},
	[PageTemplateData.SECTION_TYPES.CATEGORIES_SCORES]: {
		[CATEGORY_SCORES_VARIANTS.VARIANT_1]: 'CategoryScores1',
		[CATEGORY_SCORES_VARIANTS.VARIANT_2]: 'CategoryScores2',
		[CATEGORY_SCORES_VARIANTS.VARIANT_3]: 'CategoryScores3',
		[CATEGORY_SCORES_VARIANTS.VARIANT_4]: 'CategoryScores4',
	},
	[PageTemplateData.SECTION_TYPES.CONTENT]: {
		[CONTENT_VARIANTS.VARIANT_1]: 'Content1',
		[CONTENT_VARIANTS.VARIANT_2]: 'Content2',
		[CONTENT_VARIANTS.VARIANT_3]: 'Content3',
		[CONTENT_VARIANTS.VARIANT_4]: 'Content4',
		[CONTENT_VARIANTS.VARIANT_5]: 'Content5',
		[CONTENT_VARIANTS.VARIANT_6]: 'Content6',
		[CONTENT_VARIANTS.VARIANT_7]: 'Content7',
		[CONTENT_VARIANTS.VARIANT_8]: 'Content8',
	},
	[PageTemplateData.SECTION_TYPES.FAQ]: {
		[FAQ_VARIANTS.VARIANT_1]: 'FAQ1',
		[FAQ_VARIANTS.VARIANT_2]: 'FAQ2',
		[FAQ_VARIANTS.VARIANT_3]: 'FAQ3',
		[FAQ_VARIANTS.VARIANT_4]: 'FAQ4',
	},
	[PageTemplateData.SECTION_TYPES.FOOTER]: {
		[FOOTER_VARIANTS.VARIANT_1]: 'Footer1',
	},
	[PageTemplateData.SECTION_TYPES.FORM]: {
		[FORM_VARIANTS.VARIANT_1]: 'DefaultForm',
		[FORM_VARIANTS.VARIANT_2]: 'Form2',
		[FORM_VARIANTS.VARIANT_3]: 'Form3',
		[FORM_VARIANTS.VARIANT_4]: 'Form4',
		[FORM_VARIANTS.VARIANT_5]: 'Form5',
		[FORM_VARIANTS.VARIANT_6]: 'Form6',
		[FORM_VARIANTS.VARIANT_7]: 'Form7',
		[FORM_VARIANTS.VARIANT_8]: 'Form8',
		[FORM_VARIANTS.VARIANT_9]: 'Form9',
		[FORM_VARIANTS.VARIANT_10]: 'Form10',
		[FORM_VARIANTS.VARIANT_11]: 'Form11',
		[FORM_VARIANTS.VARIANT_12]: 'Form12',
		[FORM_VARIANTS.VARIANT_13]: 'Form13',
	},
	[PageTemplateData.SECTION_TYPES.INDIVIDUAL_CATEGORY]: {
		[INDIVIDUAL_CATEGORY_VARIANTS.VARIANT_1]: 'IndividualCategory1',
		[INDIVIDUAL_CATEGORY_VARIANTS.VARIANT_2]: 'IndividualCategory2',
		[INDIVIDUAL_CATEGORY_VARIANTS.VARIANT_3]: 'IndividualCategory3',
		[INDIVIDUAL_CATEGORY_VARIANTS.VARIANT_4]: 'IndividualCategory4',
		[INDIVIDUAL_CATEGORY_VARIANTS.VARIANT_5]: 'IndividualCategory5',
		[INDIVIDUAL_CATEGORY_VARIANTS.VARIANT_6]: 'IndividualCategory6',
		[INDIVIDUAL_CATEGORY_VARIANTS.VARIANT_7]: 'IndividualCategory7',
		[INDIVIDUAL_CATEGORY_VARIANTS.VARIANT_8]: 'IndividualCategory8',
		[INDIVIDUAL_CATEGORY_VARIANTS.VARIANT_9]: 'IndividualCategory9',
		[INDIVIDUAL_CATEGORY_VARIANTS.VARIANT_10]: 'IndividualCategory10',
		[INDIVIDUAL_CATEGORY_VARIANTS.VARIANT_11]: 'IndividualCategory11',
	},
	[PageTemplateData.SECTION_TYPES.OVER_ALL_SCORE]: {
		[OVER_ALL_SCORE_VARIANTS.DEFAULT]: 'Default',
		[OVER_ALL_SCORE_VARIANTS.RADAR]: 'Radar',
		[OVER_ALL_SCORE_VARIANTS.DONUT]: 'Donut',
		[OVER_ALL_SCORE_VARIANTS.PIE]: 'Pie',
		[OVER_ALL_SCORE_VARIANTS.SPEEDOMETER]: 'Speed',
		[OVER_ALL_SCORE_VARIANTS.THERMOMETER]: 'Thermometer',
		[OVER_ALL_SCORE_VARIANTS.TRAFFIC_LIGHT]: 'TrafficLight',
	},
	[PageTemplateData.SECTION_TYPES.POPUP]: {
		[POPUP_VARIANTS.SING_UP_LANDING]: 'SingUpLanding',
		[POPUP_VARIANTS.SING_UP_RESULT]: 'SingUpResult',
		[POPUP_VARIANTS.CHANGE_EMAIL]: 'ChangeEmail',
	},
	[PageTemplateData.SECTION_TYPES.TESTIMONIAL]: {
		[TESTIMONIAL_VARIANTS.VARIANT_1]: 'Testimonial1',
		[TESTIMONIAL_VARIANTS.VARIANT_2]: 'Testimonial2',
		[TESTIMONIAL_VARIANTS.VARIANT_3]: 'Testimonial3',
		[TESTIMONIAL_VARIANTS.VARIANT_4]: 'Testimonial4',
		[TESTIMONIAL_VARIANTS.VARIANT_5]: 'Testimonial5',
		[TESTIMONIAL_VARIANTS.VARIANT_6]: 'Testimonial6',
		[TESTIMONIAL_VARIANTS.VARIANT_7]: 'Testimonial7',
	},
	[PageTemplateData.SECTION_TYPES.VIDEO]: {
		[VIDEO_VARIANTS.VARIANT_1]: 'Video1',
		[VIDEO_VARIANTS.VARIANT_2]: 'Video2',
		[VIDEO_VARIANTS.VARIANT_3]: 'Video3',
		[VIDEO_VARIANTS.VARIANT_4]: 'Video4',
		[VIDEO_VARIANTS.VARIANT_5]: 'Video5',
		[VIDEO_VARIANTS.VARIANT_6]: 'Video6',
		[VIDEO_VARIANTS.VARIANT_7]: 'Video7',
		[VIDEO_VARIANTS.VARIANT_8]: 'Video8',
		[VIDEO_VARIANTS.VARIANT_9]: 'Video9',
	},
	[PageTemplateData.SECTION_TYPES.SMART_SECTIONS]: {
		[SMART_SECTIONS_VARIANTS.VARIANT_1]: 'SmartSections1',
		[SMART_SECTIONS_VARIANTS.VARIANT_2]: 'SmartSections2',
		[SMART_SECTIONS_VARIANTS.VARIANT_3]: 'SmartSections3',
	},
})
